import Immutable from "seamless-immutable";
import SiteActionTypes from "./actionTypes";

const initialState = Immutable({});

const SiteReducer = (state = initialState, action) => {
  switch (action.type) {
    case SiteActionTypes.GET_ONE:
      return { ...state, ...action.data };
    default:
      return state;
  }
};

export default SiteReducer;
